import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles, Theme } from '@material-ui/core/styles';
import * as yup from 'yup';
import NumberFormat from 'react-number-format';
import './financial-advisory.scss';

import InputTooltip from 'components/tooltips/InputTooltips';

const useStyles = makeStyles((theme: Theme) => ({
	input: {
		width: 290,
		height: 50,
		marginTop: 32,
		'& .MuiOutlinedInput-root': {
			backgroundColor: 'white',
		},
	},
	prefix: {
		marginTop: 1,
	},
}));

type InputAdvisoryProps = {
	inputValue: string;
	setInputError: any;
	setInputValue: any;
};
interface NumberFormatCustomProps {
	inputRef: (instance: NumberFormat | null) => void;
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			allowNegative={false}
			thousandSeparator={'.'}
			decimalSeparator={'n'}
			//isNumericString={true}
		/>
	);
}

const validationSchema = yup.object().shape({
	salary: yup
		.number()
		.required('Campo Requerido')
		.min(600000, 'Sueldo liquido  mínimo de $600.000')
		.max(99999999, 'sueldo maximo de $99.999.999')
		.integer('Debe ingresar un número'),
});

function InputAdvisory({ inputValue, setInputError, setInputValue }: InputAdvisoryProps) {
	const classes = useStyles();
	const [errorMessage, setErrorMessage] = useState('');
	const [errorState, setErrorState] = useState(false);

	const inputChange = (e: any) => {
		const salary = {
			salary: e.target.value ? e.target.value : undefined,
		};
		validationSchema
			.validate(salary)
			.then((valid) => {
				setErrorMessage('');
				setErrorState(false);
				setInputError(false);
			})
			.catch((error: yup.ValidationError) => {
				setErrorMessage(error.message);
				setErrorState(true);
				setInputError(true);
			});

		setInputValue(e.target.value);
	};

	return (
		<div className="inputAdvisory">
			<h1>Para empezar indícanos tu sueldo</h1>
			<p className="bajada">El sueldo mínimo requerido es de $600.000</p>
			<form>
				<TextField
					label="sueldo liquido"
					variant="outlined"
					required
					name="salary"
					value={inputValue}
					error={errorState}
					onChange={inputChange}
					className={classes.input}
					helperText={errorMessage}
					placeholder="600.000"
					InputProps={{
						endAdornment: (
							<InputTooltip
								title="Suma de dinero que recibes como sueldo a fin de mes."
								error={errorState}
							/>
						),
						startAdornment: (
							<InputAdornment position="start" className={classes.prefix}>
								$
							</InputAdornment>
						),
						inputComponent: NumberFormatCustom as any,
					}}
				/>
			</form>
		</div>
	);
}

export default InputAdvisory;
